import React from 'react';
import { Container, Row, Col, Media } from 'reactstrap';
import getConfig from 'next/config';
// import './giveAssuredPanel.scss';

const config = getConfig().publicRuntimeConfig;

const items = [
	{
		src: `${config.cdnUrl}/static/images/home/homev2/money-raised-icon.svg`,
		totalNumber: ' 700cr+',
		desc: 'raised for nonprofits'
	},
	{
		src: `${config.cdnUrl}/static/images/home/homev2/donors-icon.svg`,
		totalNumber: '2M+',
		desc: 'donors have contributed to causes'
	},
	{
		src: `${config.cdnUrl}/static/images/home/homev2/lives-impacted-icon.svg`,
		totalNumber: '15M+',
		desc: 'lives impacted'
	},
	{
		src: `${config.cdnUrl}/static/images/home/homev2/trusted-icon.svg`,
		totalNumber: 'Trusted',
		desc: 'by 150+ corporates and brands'
	}
];

const mediaMainBody = {
	paddingLeft: '1rem',
	fontWeight: '300',
	fontSize: '0.875rem'
};
const mediaImage = {
	marginTop: '0.5rem'
};
const outerBox = {
	paddingBottom: 0,
	paddingTop: '2rem'
};
const mediaMainHeading = {
	fontWeight: '600',
	marginBottom: '0'
};
const mediaMainHeadings = {
	fontWeight: '600',
	marginBottom: '0',
	color: '#FF5050'
};

const GiveAssuredPanelNew = () => {
	const giveassuredDetails = items.map((item, indexg) => (
		<Col
			lg="3"
			md="6"
			sm="12"
			xs="12"
			className="d-flex align-self-center"
			key={indexg}
			style={outerBox}
		>
			<div className="">
				<Media className="d-flex   align-self-center">
					<Media left className="">
						<img
							src={item.src}
							width="50"
							height="50"
							style={mediaImage}
							alt="money-raised"
						/>
					</Media>
					<Media body style={mediaMainBody}>
						<Media heading style={mediaMainHeading}>
							{item.totalNumber}
						</Media>
						<p>{item.desc}</p>
					</Media>
				</Media>
			</div>
		</Col>
	));

	const giveassuredDetailsNew = items.map((item, indexg) => (
		<Col
			lg="6"
			md="6"
			sm="12"
			xs="12"
			className="d-flex align-self-center"
			key={indexg}
			style={outerBox}
		>
			<div className="">
				<Media className="d-flex   align-self-center">
					<Media body style={mediaMainBody}>
						<Media heading style={mediaMainHeadings}>
							{item.totalNumber}
						</Media>
						<p>{item.desc}</p>
					</Media>
				</Media>
			</div>
		</Col>
	));

	return (
		<Container className="panel-padding">
			<>
				<div className="hide-for-desktop">
					<div className="giveassured-badge-image justify-content-center ">
						<img
							src={`${config.cdnUrl}/static/images/home/give-assured-badge20.png`}
							alt="give assured badge"
							style={{ height: '24pt' }}
						/>
					</div>
					<p className="giveassured-details">
						We ensure that <b>critical checks</b> are done on all nonprofits and
						their projects to assure your donation does what it is supposed to -
						change lives.
					</p>
					<div className="giveassured-readmore ">
						<a
							className=""
							href="/giveassured"
							rel="noopener noreferrer"
							target="_blank"
							onClick={() => {
								if (window.eventDispatcher) {
									window.eventDispatcher.dispatchEventSync(
										'giveassured-readmore',
										{},
										{ amplitude: true }
									);
								}
							}}
						>
							Read more
						</a>
					</div>
				</div>
				<Row
					style={{ paddingBottom: '0rem', paddingLeft: '3rem' }}
					className=" hide-for-desktop"
				>
					{giveassuredDetails}
				</Row>
			</>
			<>
				<h2 className=" hide-for-mobile giveassured-heading justify-content-center ">
					Giving you can trust
				</h2>

				<Row className="hide-for-mobile">
					<div className="giveassured-stats">
						<Col
							lg="6"
							md="6"
							sm="12"
							xs="12"
							style={{ borderRight: '1px solid #dddddd' }}
						>
							<div style={outerBox}>
								<img
									src={`${config.cdnUrl}/static/images/home/give-assured-badge20.png`}
									alt="give assured badge"
									style={{ height: '24pt' }}
								/>
								<p style={{ marginTop: '2rem' }}>
									We ensure that <b>critical checks</b> are done on all
									nonprofits and their projects to assure your donation does
									what it is supposed to - change lives. &nbsp;
									<a
										className=""
										href="/giveassured"
										rel="noopener noreferrer"
										target="_blank"
										onClick={() => {
											if (window.eventDispatcher) {
												window.eventDispatcher.dispatchEventSync(
													'giveassured-readmore',
													{},
													{ amplitude: true }
												);
											}
										}}
									>
										Read more
									</a>
								</p>
							</div>
						</Col>
						<Col lg="6" md="6" sm="12" xs="12" className="p-0">
							<Row>{giveassuredDetailsNew}</Row>
						</Col>
					</div>
				</Row>
			</>
			<style jsx>
				{`
					.giveassured-heading {
						text-align: center !important;
					}
					.giveassured-badge-image {
						text-align: center !important;
					}
					.giveassured-details {
						text-align: center !important;
						font-size: 22px;
						padding-top: 1rem;
					}
					.giveassured-readmore {
						text-align: center !important;
						color: var(--teal);
					}
					.giveassured-downpanel-iamge {
						width: 35px;
						height: 70px;
					}

					@media (max-width: 768px) {
						.giveassured-text-panel {
							padding: 1.5rem 0rem 1rem 0rem;
						}
						.giveassured-details {
							font-size: 20px;
						}
					}
					@media (min-width: 768px) {
						.giveassured-details {
							padding-left: 4rem;
							padding-right: 4rem;
						}
					}
				`}
			</style>
		</Container>
	);
};

export default GiveAssuredPanelNew;
